export enum ENavigationPath {
  ROOT = '/',
  DEFAULT = '*',
  LOGIN = '/login',
  AUTH_CALLBACK = '/auth/callback',

  // Home
  HOME = '/home',
  DASHBOARD = '/home/dashboard',
  OLD_DASHBOARD = '/home/old-dashboard',

  // Policy Management
  POLICY_MANAGEMENT = '/policy-management',
  VIEW_MASTER_CONTRACT = '/policy-management/view-master-contract',
  VIEW_BINDER_CONTRACT = '/policy-management/view-binder-contract',
  CANCEL_BINDER_CONTRACT = '/policy-management/cancel-binder-contract',
  ENDORSE_BINDER_CONTRACT = '/policy-management/endorse-binder-contract',

  // Opportunity
  OPPORTUNITY = '/opportunity',
  NEW_OPPORTUNITY = '/opportunity/new-opportunity',
  UPDATE_OPPORTUNITY = '/opportunity/update-opportunity',
  CLOSE_OPPORTUNITY = '/opportunity/close-opportunity',

  // Submissions
  SUBMISSIONS = '/submissions',
  NEW_SUBMISSION = '/submissions/new-submission',
  UPDATE_SUBMISSION = '/submissions/update-submission',
  CLOSE_SUBMISSION = '/submissions/close-submission',
  SUBMISSION_DETAIL = '/submission/detail/:submissionId/:tabId',

  // Contracts
  CONTRACTS = '/contracts',
  CONTRACT_NEW_ADJUSTMENT = '/contract/new-adjustments/:contractId',
  CONTRACT_ADJUSTMENT_DETAIL = '/contract/:contractId/adjustment/:adjustmentId',
  CONTRACT_DETAIL = '/contract/detail/:contractId/:tabId',

  // Renewals
  RENEWALS = '/renewals',
  NEW_RENEWAL_SUBMISSION = '/renewals/new-renewal-submission',
  UPDATE_RENEWAL_SUBMISSION = '/renewals/update-renewal-submission',
  CLOSE_RENEWAL_SUBMISSION = '/renewals/close-renewal-submission',
  CLONE_RENEWAL_SUBMISSION = '/renewals/clone-renewal-submission',

  // Premium Receipting
  PREMIUM_RECEIPTING = '/premium-receipting',
  UPDATE_RECEIPT = '/premium-receipting/update-receipt/:id',
  LIST_RECEIPTS = '/premium-receipting/list-receipts',
  PERFORM_CLOSING = '/premium-receipting/perform-closing',
  NEW_RECEIPT = '/premium-receipting/new-receipt',
  ALLOCATE_PREMIUM_PAYMENTS = '/premium-receipting/allocate-premium-payments',
  APPROVE_CLAIMS_PAYMENTS = '/premium-receipting/approve-claims-payments',

  // Claims
  CLAIMS = '/claims',
  REGISTER_NEW_MASTER_CLAIM = '/claims/register-new-master-claim',
  UPDATE_MASTER_CLAIM = '/claims/update-master-claim',
  CLOSE_MASTER_CLAIM = '/claims/close-master-claim',
  UPDATE_BINDER_CLAIM = '/claims/update-binder-claim',
  CLOSE_BINDER_CLAIM = '/claims/close-binder-claim',
  CLAIM_DETAIL = '/claims/detail/:claimId/:tabId',

  // Bordereaux Reports
  BORDEREAUX_REPORTS = '/bordereaux-reports',
  NEW_BORDEREAUX = '/bordereaux-reports/new',
  EXISTING_BORDEREAUX = '/bordereaux-reports/existing',

  // Portfolio Analysis
  PORTFOLIO_ANALYSIS = '/portfolio-analysis',

  // Reference Data
  REFERENCE_DATA = '/reference-data',
  INSURED_RECORDS = '/reference-data/insured-records',
  REINSURED_RECORDS = '/reference-data/reinsured-records',
  NEW_INSURED = '/reference-data/insured-records/new-insured',
  NEW_REINSURED = '/reference-data/reinsured-records/new-reinsured',
  UPDATE_REINSURED = '/reference-data/reinsured-records/update-reinsured/:id',
  BROKER_RECORDS = '/reference-data/broker-records',
  NEW_BROKER = '/reference-data/broker-records/new-broker',
  UPDATE_BROKER = '/reference-data/broker-records/update-broker/:id',
  BINDER_RECORDS = '/reference-data/binder-records',
  NEW_BINDER = '/reference-data/binder-records/new-binder',
  UPDATE_BINDER = '/reference-data/binder-records/update-binder/:id',
  CURRENCY = '/reference-data/currency',
  PRICING_ASSUMPTIONS = '/reference-data/pricing-assumptions',
  FIRE_SEVERITY_CURVES = '/reference-data/pricing-assumptions/fire-severity-curves',
  CAT_ZONE_RATES = '/reference-data/pricing-assumptions/cat-zone-rates',
  FIRE_RATES = '/reference-data/pricing-assumptions/fire-rates',
  ADEQUACY_ASSUMPTIONS = '/reference-data/pricing-assumptions/adequacy-assumptions',
  REFERENCE_DATA_PRICING = '/reference-data/pricing-assumptions/reference-data',
  UPDATE_INSURED = '/reference-data/insured-records/:id/update',
  NEW_CAT_EVENT = '/reference-data/cat-event-records/new-cat-event',
  UPDATE_CAT_EVENT = '/reference-data/cat-event-records/update-cat-event/:id',
  CAT_EVENT_RECORDS = '/reference-data/cat-event-records',

  // Tools and Utilities
  TOOLS_AND_UTILITIES = '/tools-and-utilities',

  // Settings
  SETTINGS = '/settings',
}

export enum EPath {
  DEFAULT = '*',
  LOGIN = '/login',

  // Home
  HOME = '/home',
  DASHBOARD = '/dashboard',

  // Policy Management
  POLICY_MANAGEMENT = '/policy-management',
  VIEW_MASTER_CONTRACT = '/view-master-contract',
  VIEW_BINDER_CONTRACT = '/view-binder-contract',
  CANCEL_BINDER_CONTRACT = '/cancel-binder-contract',
  ENDORSE_BINDER_CONTRACT = '/endorse-binder-contract',

  // Opportunity
  OPPORTUNITY = '/opportunity',
  NEW_OPPORTUNITY = '/new-opportunity',
  UPDATE_OPPORTUNITY = '/update-opportunity',
  CLOSE_OPPORTUNITY = '/close-opportunity',

  // Submissions
  SUBMISSIONS = '/submissions',
  NEW_SUBMISSION = '/new-submission',
  UPDATE_SUBMISSION = '/update-submission',
  CLOSE_SUBMISSION = '/close-submission',
  CLONE_SUBMISSION = '/clone-submission',

  // Renewals
  RENEWALS = '/renewals',
  NEW_RENEWAL_SUBMISSION = '/new-renewal-submission',
  UPDATE_RENEWAL_SUBMISSION = '/update-renewal-submission',
  CLOSE_RENEWAL_SUBMISSION = '/close-renewal-submission',
  CLONE_RENEWAL_SUBMISSION = '/clone-renewal-submission',

  // Premium Receipting
  PREMIUM_RECEIPTING = '/premium-receipting',
  UPDATE_RECEIPT = '/update-receipt/:id',
  LIST_RECEIPTS = '/list-receipts',
  PERFORM_CLOSING = '/perform-closing',
  NEW_RECEIPT = '/new-receipt',
  ALLOCATE_PREMIUM_PAYMENTS = '/allocate-premium-payments',
  APPROVE_CLAIMS_PAYMENTS = '/approve-claims-payments',

  // Claims
  CLAIMS = '/claims',
  REGISTER_NEW_MASTER_CLAIM = '/register-new-master-claim',
  UPDATE_MASTER_CLAIM = '/update-master-claim',
  CLOSE_MASTER_CLAIM = '/close-master-claim',
  UPDATE_BINDER_CLAIM = '/update-binder-claim',
  CLOSE_BINDER_CLAIM = '/close-binder-claim',

  // Bordereaux Reports
  BORDEREAUX_REPORTS = '/bordereaux-reports',
  NEW_BORDEREAUX = '/new',
  EXISTING_BORDEREAUX = '/existing',

  // Portfolio Analysis
  PORTFOLIO_ANALYSIS = '/portfolio-analysis',

  // Reference Data
  REFERENCE_DATA = '/reference-data',
  INSURED_RECORDS = '/insured-records',
  REINSURED_RECORDS = '/reinsured-records',
  NEW_INSURED = '/reinsured-records/new-insured',
  BROKER_RECORDS = '/broker-records',
  NEW_BROKER = '/broker-records/new-broker',
  BINDER_RECORDS = '/binder-records',
  CURRENCY = '/currency',
  PRICING_ASSUMPTIONS = '/pricing-assumptions',
  CAT_EVENT_RECORDS = '/cat-event-records',
  FIRE_SEVERITY_CURVES = '/pricing-assumptions/fire-severity-curves',
  CAT_ZONE_RATES = '/pricing-assumptions/cat-zone-rates',
  FIRE_RATES = '/pricing-assumptions/fire-rates',
  ADEQUACY_ASSUMPTIONS = '/pricing-assumptions/adequacy-assumptions',
  REFERENCE_DATA_PRICING = '/pricing-assumptions/reference-data',

  // Tools and Utilities
  TOOLS_AND_UTILITIES = '/tools-and-utilities',

  // Settings
  SETTINGS = '/settings',
}

export const constructSubmissionDetailPath = (
  submissionId: string,
  tabId = '0'
) => {
  return `/submission/detail/${submissionId}/${tabId}`;
};

export const constructContractDetailPath = (
  contractId: string,
  tabId = '0'
) => {
  return `/contract/detail/${contractId}/${tabId}`;
};

export const constructClaimDetailPath = (claimId: string, tabId = '0') => {
  return `/claims/detail/${claimId}/${tabId}`;
};

export const constructAdjustmentDetailPath = (
  contractId: string,
  adjustmentId: string
) => {
  return `/contract/${contractId}/adjustment/${adjustmentId}`;
};

export enum EPageFrom {
  BINDING_DASHBOARD = 'bindingDashboard',
  FINANCE_DASHBOARD = 'financeDashboard',
}

export enum EPageTo {
  FINANCE_DASHBOARD = 'financeDashboard',
  CONTRACT_DETAIL = 'contractDetail',
}
